import { scenarioLabel } from "./trainingReviewQueueShared";
import type { ArchivedRoleplaySession } from "@/lib/training/trainingApiClient";

export function TrainingReviewArchivedList(props: {
  sessions: ArchivedRoleplaySession[];
  loading: boolean;
  err: string | null;
  onRefresh: () => void;
}) {
  const { sessions, loading, err, onRefresh } = props;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="text-sm font-semibold text-indigo-700 hover:text-indigo-900"
          onClick={() => void onRefresh()}
          disabled={loading}
        >
          {loading ? "Loading…" : "Refresh archived"}
        </button>
      </div>
      {err ? <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-3 py-2">{err}</div> : null}
      {!loading && sessions.length === 0 ? (
        <div className="text-sm text-gray-600 border border-gray-200 rounded-xl p-4 bg-gray-50 dark:bg-gray-900/40 dark:border-gray-700">
          No archived sessions yet. Submitting a review with “Archive transcript” enabled moves reviewed sessions here and
          removes the live transcript.
        </div>
      ) : null}
      <ul className="space-y-2">
        {sessions.map((s) => (
          <li
            key={s.id}
            className="border border-gray-200 dark:border-gray-700 rounded-xl bg-white dark:bg-gray-900 px-4 py-3 text-sm"
          >
            <div className="font-semibold text-gray-900 dark:text-gray-100">
              {s.traineeLabel ?? "Trainee"} · {scenarioLabel(s.scenario_key)}
            </div>
            <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
              Scored {s.overall_score != null ? `${s.overall_score.toFixed(1)}/10` : "—"} · Archived{" "}
              {s.archived_at ? new Date(s.archived_at).toLocaleString() : "—"}
            </div>
            {s.summary ? <p className="text-xs text-gray-700 dark:text-gray-300 mt-2 italic line-clamp-3">{s.summary}</p> : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
